"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ObjectId = require('bson').ObjectID;

var tv4 = require('tv4');

var PersonReference = require('../core/person-reference');

var InventoryHazardSignReference = /*#__PURE__*/function () {
  function InventoryHazardSignReference(opt) {
    _classCallCheck(this, InventoryHazardSignReference);

    this._id = null;
    this.name = null;
    this.owner = null;
    this.lastCertifiedDate = null;

    if (opt) {
      this.fillObject(opt);
    }
  }

  _createClass(InventoryHazardSignReference, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this._id = opt._id ? new ObjectId(opt._id) : null;
      this.name = opt.name;
      this.owner = opt.owner ? new PersonReference(opt.owner) : null;
      this.lastCertifiedDate = opt.lastCertifiedDate ? new Date(opt.lastCertifiedDate) : null;
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, InventoryHazardSignReference.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'inventory-hazard-sign-reference.schema.json',
        type: 'object',
        properties: {
          _id: {
            type: 'object'
          },
          name: {
            type: 'string'
          },
          owner: {
            $ref: 'person-reference.schema.json'
          },
          lastCertifiedDate: {
            type: ['object', null]
          }
        },
        required: Object.keys(this)
      };
    }
  }]);

  return InventoryHazardSignReference;
}();

module.exports = InventoryHazardSignReference;